<div class="content-heading">
    <div class="header-container">
        <h3>Compulsa Centro de ventas</h3>
        <small>Ajuste de inventario</small>
    </div>
</div>

<div class="container-fluid">

    <div class="col-lg-12">
        <div class="card card-default">
            <div class="card-body">
                <!-- inicio filtros -->
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-12 form-group">
                        <label class="form-label">Centro de ventas</label>
                        <ceq-unit-autocomplete [loading]="adjusRunning"
                                               [listType]="'CEVE'"
                                               [unitOrgId]="0"
                                               (onUnitClear)="clearNode()"
                                               (onUnitSelected)="changeNode($event)"></ceq-unit-autocomplete>
                    </div>
                    <div class="mt-auto ml-2" *ngIf="!adjusRunning && hasStatusActivity && !showHistory">
                        <div class="form-group">
                            <button *ngIf="!loading"
                                    class="mr-1  btn btn-labeled btn-outline-warning mb-2"
                                    (click)="ValidateAdjustState()"
                                    [disabled]="loading">
                                <span class="btn-label">
                                    <i style="font-size: 1.5em;margin-top:4px;"  class="fa fa-check"></i>
                                </span>
                                <span>Validar prerrequisitos</span>
                            </button>
                            <button *ngIf="loading"
                                    class="mr-1  btn btn-labeled btn-outline-warning mb-2"
                                    [disabled]="loading">
                                <span class="btn-label">
                                    <i style="font-size: 1.5em;margin-top:4px;"  class="fa fa-circle-notch fa-spin"></i>
                                </span>
                                <span>Validando prerequisitos</span>
                            </button>
                        </div>
                    </div>
                    <div class="mt-auto ml-2" *ngIf="!adjusRunning && hasViewActivity && !showHistory">
                        <div class="form-group">
                            <button *ngIf="!loading"
                                    class="bmr-1 btn btn-labeled btn-outline-primary mb-2"
                                    (click)="ViewCurrentAdjust()"
                                    [disabled]="loading">
                                <span class="btn-label">
                                    <i style="font-size: 1.5em;margin-top:4px;"  class="fa fa-eye"></i>
                                </span>
                                <span>Visualizar Compulsa</span>
                            </button>

                            <button *ngIf="loading"
                                    class="mr-1 btn btn-labeled btn-outline-primary mb-2"
                                    [disabled]="loading">
                                <span class="btn-label">
                                    <i style="font-size: 1.5em;margin-top:4px;"  class="fa fa-circle-notch fa-spin"></i>
                                </span>
                                <span>Cargando</span>
                            </button>
                        </div>
                    </div>

                    <div class="ml-auto mt-auto d-flex">
                        <div class="mr-2" *ngIf="useV2 && showHistoryButtons ">
                            <div class="form-group">
                                <button *ngIf="!loading"
                                        class="bmr-1 btn btn-labeled btn-outline-success mb-2"
                                        (click)="showAdjustHistory()"
                                        [disabled]="loading">
                                    <span class="btn-label">
                                        <i style="font-size: 1.5em;margin-top:4px;"  class="fa fa-history"></i>
                                    </span>
                                    <span>Consultar Historicos</span>
                                </button>
                            </div>
                        </div>
                        <div class="mr-2" *ngIf="useV2 && showHistoryButtons && showHistory">
                            <div class="form-group">
                                <button *ngIf="!loading"
                                        class="bmr-1 btn btn-labeled btn-outline-danger mb-2"
                                        (click)="hideAdjustHistory()"
                                        [disabled]="loading">
                                    <span class="btn-label">
                                        <i style="font-size: 1.5em;margin-top:4px;"  class="fas fa-eye-slash"></i>
                                    </span>
                                    <span>Ocultar Historicos</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- fin filtros -->

                <div class="row" *ngIf="!adjusRunning && !showHistory">
                    <div class="col col-md-12 col-sm-12">
                        <h3>Tr&aacute;nsitos</h3>
                        <hr>
                    </div>
                    <!--Grid-->
                    <div class="col col-md-12 col-sm-12 form-group">
                        <app-ceq-table #CeqGrid
                                       [gridAdditionalOptions]="gridOptions"
                                       [columnDef]="columnDefs"
                                       (apiEmitter)="gridEmiter($event)">
                        </app-ceq-table>
                    </div>
                </div>

                <!-- inicio historicos -->
                <div class="row d-flex" *ngIf="!adjusRunning && showHistory">
                    <div class="col col-md-12 col-sm-12">
                        <h3>Historicos</h3>
                        <hr>
                    </div>
                    <!--Grid-->
                    <app-loading *ngIf="loading" class="ml-auto mr-auto"></app-loading>
                    <table class="table table-bordered table-striped w-80 ml-auto mr-auto" *ngIf="!loading">
                        <thead>
                            <tr class="background-nav-color">
                                <th scope="col">N&uacute;mero compulsa</th>
                                <th scope="col">Fecha de compulsa</th>
                                <th scope="col">Duraci&oacute;n de compulsa</th>
                                <th scope="col">Visualizar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of adjustHistory">
                                <td class="text-center align-middle">{{item.AdjustCode}}</td>
                                <td class="text-center align-middle">{{item.CreatedAt | date:'dd-MM-yyyy HH:mm:ss'}}</td>
                                <td class="text-center align-middle">{{item.AdjustCountdown}}</td>
                                <td class="text-center align-middle">
                                    <button class="bmr-1 btn btn-labeled btn-outline-primary mb-2"
                                            (click)="showAdjustHistoryDetail(item)">
                                        <span class="btn-label">
                                            <i style="font-size: 1.5em;margin-top:4px;"  class="fa fa-eye"></i>
                                        </span>
                                        <span>Visualizar Compulsa</span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- fin historicos -->

                <app-adjust-ceve-cut
                                     *ngIf="adjusRunning && !useV2"
                                     [selectedNodeCut]="selectedNode"
                                     [adjustNode]="activeAdjust"
                                     (parentCancelAdjust)="cancelAdjust()">
                </app-adjust-ceve-cut>

                <hr *ngIf="adjusRunning && useV2">
                <app-adjust-ceve-cut-v2
                                        *ngIf="adjusRunning && useV2"
                                        [SelectedUnit]="selectedNode"
                                        [ActiveAdjust]="activeAdjust"
                                        (OnAdjustCanceled)="cancelAdjust()">
                </app-adjust-ceve-cut-v2>

            </div>
        </div>
    </div>

</div>